import { render, staticRenderFns } from "./ArrayTable.vue?vue&type=template&id=201dde58&scoped=true&"
import script from "./ArrayTable.vue?vue&type=script&lang=js&"
export * from "./ArrayTable.vue?vue&type=script&lang=js&"
import style0 from "./ArrayTable.vue?vue&type=style&index=0&id=201dde58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201dde58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201dde58')) {
      api.createRecord('201dde58', component.options)
    } else {
      api.reload('201dde58', component.options)
    }
    module.hot.accept("./ArrayTable.vue?vue&type=template&id=201dde58&scoped=true&", function () {
      api.rerender('201dde58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/com/ArrayTable.vue"
export default component.exports